var render = function render(){var _vm=this,_c=_vm._self._c;return _c('servicos',{attrs:{"permitirAprovar":false,"permitirReprovar":false,"permiteDetalhar":_vm.$temAcessoView('GESCON-FORN-SERV-00'),"rotaDetalhar":"Fornecedor_Contratos_Servicos_Detalhar","rotaListagem":"Fornecedor_Contratos_Servicos_Listagem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }